export const TOOLTIP_DELAY = 100;
export const DEFAULT_VERSION_PATH = 'latest';
